<div
  class="dropdown dropdown-form-control dropdown-form-control-sm"
  dropdown
  (onHidden)="onHide()"
  (onShown)="onShow()"
  #dropdown="bs-dropdown"
  [insideClick]="true"
>
  <button
    dropdownToggle
    [class]="btnClasses"
    type="button"
  >
    {{ getMainText(this.value, this.items) }}
  </button>
  <div class="dropdown-menu dropdown-menu-lender show" *dropdownMenu
  >
  <ng-scrollbar class="scroll-height">
      <div dir="ltr">
          <span
            class="dropdown-item dropdown-item-lender"
            [class.active]="includes(item)"
            (click)="checkItem(item)"
            *ngFor="let item of items"
          >
            <div class="media media-table">
              <div class="media-body">
                <h5>
                  <div
                    class="media-checkbox"
                    *ngIf="!item.removeCheckbox"
                  ></div>
                  <div class="title-media-checkbox">{{ item.label }}</div>
                </h5>
              </div>
            </div>
          </span>
      </div>
  </ng-scrollbar>

    <div class="dropdown-footer-btn">
      <button
        type="button"
        class="btn btn-outline-secondary btn-sm"
        (click)="apply(dropdown)"
      >
        {{'shared.component.multi-select-dropdown.apply' | translate}}
      </button>
    </div>
  </div>
</div>
